export default "__VITE_ASSET__C6cf_X1D__"